import type React from "react";
import { cn } from "../../utils/classMerger";

interface DashboardHeaderProps {
    heading: string;
    text?: string;
    children?: React.ReactNode;
    className?: string;
}

export function DashboardHeader({
    heading,
    text,
    children,
    className,
}: DashboardHeaderProps) {
    return (
        <div
            className={cn("flex items-center justify-between px-2", className)}
        >
            <div className="grid gap-1">
                <h1 className="text-2xl text-primary font-bold tracking-tight md:text-3xl">
                    {heading}
                </h1>
                {text && <p className="text-muted-foreground">{text}</p>}
            </div>
            {children}
        </div>
    );
}
